import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AplicativoDTO } from '../dto/AplicativoDTO';

const API_URL = "https://appdetprod.codelco.cl:91/enlace/api_azure/";
//const API_URL = "https://localhost:44379/api/";
//const API_URL = "https://localhost:44304/api/";
//const API_URL = "http://10.18.18.147/APIGDI_DEV/api/";
//const API_URL = "http://10.18.18.147/API_GDI/api/";

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  
  constructor(private http:HttpClient) { }

  ObtenerApps():Observable<AplicativoDTO[]>{
    return this.http.get<AplicativoDTO[]>(API_URL+ "AppsCodelco/ObtenerApps");
  }
}
